<app-user-profile [user]="user()" />
